export enum PurchaseTotalCondition {
  GREATER = "GREATER",
  LESS = "LESS",
  EQUAL = "EQUAL",
}
